import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  APPROVE_STATUS_R,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_ARE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  AUTH_STATUS_WARNING,
} from "constants/FormatDataContanst";
import { LINK_TYPE } from "constants/IssueInvoiceConstant";
import { convertToDD_MM_YYY } from "helpers/utils";
import React from "react";
import { tableFormateDate } from "../utils";

export const getReportStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      text: "Tạo mới",
      badgeColor: "badge-soft-secondary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: "Đang xử lý",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: "Hoàn tất import",
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_AR]: {
      text: "Hợp lệ",
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_REJECT]: {
      text: "Lỗi validate",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_WARNING]: {
      text: "Cảnh báo",
      badgeColor: "badge-soft-warning",
    },
  };

  const APPROVE_STATUS = {
    [APPROVE_STATUS_M]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-info",
    },
    [APPROVE_STATUS_P]: {
      //""Gửi chờ duyệt",",
      text: "Gửi chờ duyệt",
      badgeColor: "badge-soft-warning",
    },
    [APPROVE_STATUS_A]: {
      //"Đã duyệt",
      text: "Đã duyệt",
      badgeColor: "badge-soft-success",
    },
    [APPROVE_STATUS_R]: {
      //"Từ chối duyệt",
      text: "Từ chối duyệt",
      badgeColor: "badge-soft-danger",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
    APPROVE_STATUS: APPROVE_STATUS,
  };
};

export const getReportPortalStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      text: "Tạo mới",
      badgeColor: "badge-soft-secondary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: "Đang xử lý",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: "Hoàn tất",
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_AR]: {
      text: "Hợp lệ",
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_REJECT]: {
      text: "Lỗi validate",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_WARNING]: {
      text: "Cảnh báo",
      badgeColor: "badge-soft-warning",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
  };
};

export const getTimeContent = cellContent => {
  if (cellContent.month) {
    return `Tháng ${cellContent.month}_${cellContent.year}`;
  }
  if (cellContent.quarter) {
    return `Quý ${cellContent.quarter}_${cellContent.year}`;
  }
  if (cellContent.date && cellContent.date.length === 2) {
    return `${convertToDD_MM_YYY(cellContent.date[0])} ~ ${convertToDD_MM_YYY(
      cellContent.date[1]
    )}`;
  }
  if (cellContent.date_from && cellContent.date_to) {
    return `${convertToDD_MM_YYY(
      cellContent.date_from,
      "_"
    )}_${convertToDD_MM_YYY(cellContent.date_to, "_")}`;
  }
  return "";
};

export const TCTBAO_LABEL = {
  0: "0 - Mới",
  1: "1 - Hủy",
  2: "2 - Điều chỉnh",
  3: "3 - Thay thế",
  4: "4 - Giải trình",
  5: "5 - Sai sót do tổng hợp",
};

export const getRowInvoiceReplaceAdjustInfo = (
  row,
  setDataCompare,
  dispatch,
  getDataLink,
  toggleCompareInvoiceModal
) => {
  let info = null;
  let dataCompare = {
    leftInvoice: null,
    rightInvoice: null,
    tthdlquan_tchdon: null,
    typeChange: null,
  };
  let textInfo = "";
  let isChild = false;
  // $link_type Đánh dấu trạng thái liên kết điều chỉnh/thay thế 1 => parent replace , 2 => parent adjust , 3 => child replace , 4 => child adjust
  if (row.link_type) {
    switch (row.link_type) {
      // Parent
      case LINK_TYPE.PARENT_REPLACE:
        isChild = true;
        dataCompare.typeChange = " thay thế";
        break;
      case LINK_TYPE.PARENT_ADJUST:
        isChild = true;
        dataCompare.typeChange = " điều chỉnh";
        break;
      // Child
      case LINK_TYPE.CHILD_REPLACE:
        isChild = false;
        dataCompare.typeChange = " thay thế";
        break;
      case LINK_TYPE.CHILD_ADJUST:
        isChild = false;
        dataCompare.typeChange = " điều chỉnh";
        break;
      // Child
      case LINK_TYPE.CHILD_REPLACE_TT32:
        isChild = false;
        dataCompare.typeChange = " thay thế";
        break;
      case LINK_TYPE.CHILD_ADJUST_TT32:
        isChild = false;
        dataCompare.typeChange = " điều chỉnh";
        break;
      default:
        break;
    }
  }
  if (isChild) {
    dataCompare.leftInvoice = {
      current: "",
      id: row?.invoice_id,
      khmshdon: row?.khmshdon,
      khhdon: row?.khhdon,
      shdon: row?.shdon,
      nlap: tableFormateDate(row?.nlap),
    };
  }
  // ID của hóa đơn bị hóa đơn hiện tại thay thế/ điều chỉnh
  if (!isChild) {
    textInfo = " bị";
    dataCompare.rightInvoice = [
      {
        current: "",
        id: row?.invoice_id,
        khmshdon: row?.khmshdon,
        khhdon: row?.khhdon,
        shdon: row?.shdon,
        nlap: tableFormateDate(row?.nlap),
      },
    ];
  }
  dataCompare.currentId = row?.invoice_id;
  info = (
    <i
      style={{ cursor: "pointer" }}
      title={"Hiển thị thông tin hóa đơn" + textInfo + dataCompare.typeChange}
      className="font-size-17 bx bx-info-circle text-info"
      onClick={() => {
        // TO_DO
        setDataCompare(dataCompare);
        if (row?.link_type) {
          dispatch(getDataLink(row.invoice_id, isChild));
        }
        toggleCompareInvoiceModal();
      }}
    ></i>
  );
  return info;
};

export const getInvoiceStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: "Đang ký",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: "Đã phát hành",
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_REJECT]: {
      text: "Từ chối phát hành",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_AR]: {
      text: "Đã tiếp nhận đăng ký",
      badgeColor: "badge-soft-info",
    },
    [AUTH_STATUS_ARE]: {
      text: "Đã tiếp nhận thay đổi",
      badgeColor: "badge-soft-info",
    },
    [AUTH_STATUS_WARNING]: {
      text: "Cảnh báo",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_RR]: {
      text: "Từ chối tiếp nhận đăng ký",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_RRE]: {
      text: "Từ chối tiếp nhận thay đổi",
      badgeColor: "badge-soft-danger",
    },
  };

  const APPROVE_STATUS = {
    [APPROVE_STATUS_M]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-info",
    },
    [APPROVE_STATUS_P]: {
      //""Gửi chờ duyệt",",
      text: "Gửi chờ duyệt",
      badgeColor: "badge-soft-warning",
    },
    [APPROVE_STATUS_A]: {
      //"Đã duyệt",
      text: "Đã duyệt",
      badgeColor: "badge-soft-success",
    },
    [APPROVE_STATUS_R]: {
      //"Từ chối duyệt",
      text: "Từ chối duyệt",
      badgeColor: "badge-soft-danger",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
    APPROVE_STATUS: APPROVE_STATUS,
  };
};
